class PrivacyController {
    /*@ngInject*/
    constructor($log, $http, $rootScope, CommonService) {
        $log.debug('PrivacyController initialized');
        this.CommonService = CommonService;
        this.$http = $http;
        this.showBanner = false;
        this.$log = $log;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.showBanner = this.CommonService.getPersonalizeRequestResponse().showCookieBanner;
            if (this.showBanner) {
                $('.page-footer').css({'margin-bottom': $('.c-cookie').outerHeight()});
            }
        });
    }

    acceptPrivacy() {
        let url = this.CommonService.getBaseUrl() + '/privacy/accept';
        let req = {
            method: 'POST',
            url: url
        };

        this.$http(req).then((response) => {
            this.$log.debug('privacy accepted');
            this.showBanner = false;
            $('.page-footer').css({'margin-bottom': ''});
        }, (error) => {
            this.$log.error('PrivacyController: ' + error.status + ' ' + error.statusText);
        });
    }
}

export default PrivacyController;